import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogActions, MatDialogContent } from '@angular/material/dialog';
import { I18nModule } from '@spartacus/core';
import { AddressSuggestionsComponent } from './address-suggestions.component';

@NgModule({
  declarations: [AddressSuggestionsComponent],
  imports: [CommonModule, MatDialogContent, MatDialogActions, I18nModule],
  providers: [
  ],
})
export class AddressSuggestionsModule {}
